import { HttpGuardService } from 'src/app/guards/http-guard.service';
import { Injectable } from '@angular/core';
import { ApiConstants } from 'src/app/constants/api-constants';
import { EntityPage } from 'src/app/model';

@Injectable({
  providedIn: 'root'
})
export class DtcServiceService {

  constructor(private httpGuard: HttpGuardService) { }

  getDtcListing(pageNo: any, reqPayload: any) {
    return this.httpGuard.httpReq('post', 'API_ENDPOINT', `${ApiConstants.URL.getDtcList}/${pageNo}`, reqPayload, true);
  }

  getDtcCount(payload:any, pageType?: string, loader?: boolean) {
    return this.httpGuard.httpReq('post', 'API_ENDPOINT', ApiConstants.URL.getDtcCount, payload, loader ?? false, 'events', pageType);
  }

  getDtcSeverity(payload:any) {
    return this.httpGuard.httpReq('post', 'API_ENDPOINT', ApiConstants.URL.getDtcSeverity, payload, false);
  }

  getDtcState(payload: any) {
    return this.httpGuard.httpReq('post', 'API_ENDPOINT', ApiConstants.URL.getDtcState, payload, false);
  }

  addDtc(payload: any) {
    return this.httpGuard.httpReq('post', 'API_ENDPOINT', ApiConstants.URL.addDtc, payload, true);
  }

  updateDtc(payload: any, id: string) {
    return this.httpGuard.httpReq('patch', 'API_ENDPOINT', `${ApiConstants.URL.addDtc}/${id}`, payload, true);
  }

  inventoryDownload(inventoryApiType : string) {
    return this.httpGuard.httpReq('get-blob', 'API_ENDPOINT', ApiConstants.URL?.[inventoryApiType], null, false);
  }

  bulkUpload(payload: any, apiType : string) {
    return this.httpGuard.httpReq('post', 'API_ENDPOINT', ApiConstants.URL?.[apiType], payload, true);
  }

  getDtcAge(payload: any) {
    return this.httpGuard.httpReq('post', 'API_ENDPOINT', ApiConstants.URL.dtcAge, payload, false);
  }
}
